export default {
    callable: (element: HTMLElement) => {
        let handles: ReturnType<typeof setTimeout>[] = [];
        swipeDesktop(element);
        createObserver();

        function createObserver() {
            let observer;

            let options = {
                root: null,
                rootMargin: '0px',
                threshold: [0.1, 0.6],
            };

            observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(element);
        }

        function handleIntersect(entries: IntersectionObserverEntry[]) {
            entries.forEach((entry) => {
                if (entry.intersectionRatio < 0.3) {
                    clearTimeouts(handles);
                }
                if (entry.intersectionRatio > 0.5) {
                    handles = enableAutoSwipe(element);
                }
            });
        }

        function swipeDesktop(element: HTMLElement) {
            let isDown = false;
            let startX: number;
            let scrollLeft: number;

            element.addEventListener('mousedown', (e) => {
                isDown = true;
                element.classList.add('active');
                element.classList.add('scroll-override');
                startX = e.pageX - element.offsetLeft;
                scrollLeft = element.scrollLeft;

                document.body.addEventListener('click', function (event) {
                    if (element.contains(event.target as Node)) {
                        event.preventDefault();
                    }
                });

                clearTimeouts(handles);
            });

            element.addEventListener('mouseleave', () => {
                isDown = false;
                element.classList.remove('active');
            });

            element.addEventListener('mouseup', () => {
                isDown = false;
                element.classList.remove('active');
                element.classList.remove('scroll-override');
            });

            element.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                e.preventDefault();
                const x = e.pageX - element.offsetLeft;
                const walk = (x - startX) * 3;
                element.scrollLeft = scrollLeft - walk;
            });
        }
    },
};

function enableAutoSwipe(element: HTMLElement) {
    const handles: ReturnType<typeof setTimeout>[] = [];
    const swipes = numberOfSwipes(element);
    let timeout = 1200;

    for (let index = 0; index < swipes; index++) {
        handles.push(
            setTimeout(() => {
                element.scrollBy({
                    top: 0,
                    left: element.clientWidth,
                    behavior: 'smooth',
                });
            }, timeout)
        );
        timeout = timeout + 1200;
    }
    handles.push(
        setTimeout(() => {
            element.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }, timeout)
    );

    return handles;
}

function clearTimeouts(handles: ReturnType<typeof setTimeout>[]) {
    handles.forEach((handle) => {
        clearTimeout(handle);
    });
}

function numberOfSwipes(element: HTMLElement) {
    const totalElementsAttribute = element.getAttribute('data-total-elements');
    if (totalElementsAttribute) {
        const parsed = parseInt(totalElementsAttribute);
        if (!isNaN(parsed)) {
            if (parsed > 0) {
                return parsed - 1;
            }
        }
    }
    return 0;
}
